import { useRef } from 'react'

import { GlobalCommandModal } from '../../components/GlobalCommandModal'
import { GetGlobalSearchResultsPresenter } from '../../features/get-global-search-results/presenters/GetGlobalSearchResultsPresenter'
import { useGlobalSearchHotkey } from '../../hooks/useGlobalSearchHotkey'
import { useGlobalSearch } from '../../providers/GlobalSearchProvider'

export const GlobalCommandView = () => {
  const { isOpen, open, close } = useGlobalSearch()
  const searchInputRef = useRef<HTMLInputElement>(null)

  useGlobalSearchHotkey(open)

  const focusSearchInput = () => {
    searchInputRef.current?.focus()
  }

  return (
    <GlobalCommandModal
      isOpen={isOpen}
      onClose={close}
      onEntered={focusSearchInput}
    >
      <GetGlobalSearchResultsPresenter
        inputRef={searchInputRef}
        onClose={close}
      />
    </GlobalCommandModal>
  )
}
